import React, { useState } from 'react';
import { Col, Card, Button } from 'antd';
import { ShoppingCartOutlined } from '@ant-design/icons';
import { formatPrice } from '../../../../utils/utils';
import { summaryImg } from '../styles';
import { ProductItem } from '../../../../types/summary';

const { Meta } = Card;

interface ProductCardProps {
  item: ProductItem;
}

const ProductCard: React.FC<ProductCardProps> = ({ item }) => {
  const [hovered, setHovered] = useState(false);

  function capitalizeFirstLetter(str?: string): string {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  return (
    <Col span={24} md={12} lg={8}>
      <Card
        hoverable
        cover={item.img && <img alt="" style={summaryImg} src={item.img} />}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}>
        <Meta
          title={item.title}
          description={
            <>
              <p>${formatPrice(item.price)}</p>
              <p style={{ minHeight: '22px' }}>{capitalizeFirstLetter(item.description)}</p>
              <div style={{ minHeight: '32px' }}>
                {item.url && (
                  <Button
                    type="primary"
                    icon={<ShoppingCartOutlined />}
                    href={item.url}
                    disabled={!item.url}
                    target="_blank"
                    style={{ marginTop: '10px', float: 'right' }}>
                    {hovered ? 'Check in store' : ''}
                  </Button>
                )}
              </div>
            </>
          }
        />
      </Card>
    </Col>
  );
};

export default ProductCard;
